import * as yup from "yup";
import { MeasurementForm, MeasurementType } from "./interface";

const addOrChangeSchema = (translate: Function) => yup.object().shape({
	okb001Descricao: yup.string(),
	okb001Titulo: yup.string().required(translate("Título é requerido")),
	okb001Efa005Id: yup.string().required(translate("Responsável é requerido")),
	okb001Tipomedicao: yup.string().required(translate("Tipo de medição é requerido")),
	okb001Formamedicao: yup.string().required(translate("Forma de medição é requerido")),
	okb001Valorinicial: yup.string().required(translate("Valor inicial é requerido")),
	okb001Meta: yup.string().required(translate("Meta é requerido")),
	oktbb002001: yup.array().when("okb001Tipomedicao", {
		is: MeasurementType.MILESTONE,
		then: yup.array().of(yup.object().shape({
			okb002Id: yup.string(),
			okb002Titulo: yup.string().required(translate("Título é requerido")),
			oktbb003: yup.array().of(yup.object().shape({
				okb003Descricao: yup.string().required(translate("Descrição é requerido")),
				okb003Id: yup.string(),
				okb003Percincr: yup.string().required(translate("Título é requerido"))
			})).required(translate("É necessario preencher ao menos um item de milestone"))
		})).required(translate("É necessario preencher ao menos um milestone"))
	}),
	oktbb007: yup.array().when("okb001Formamedicao", {
		is: MeasurementForm.INDICATORS,
		then: yup.array().of(yup.object().shape({
			okb007Id: yup.string(),
			okb007Iqc001Id: yup.string().required(translate("Indicador é requerido")),
			okb007Peso: yup.number()
		}))
			.min(1, translate("É necessario preencher ao menos um indicador"))
			.required(translate("É necessario preencher ao menos um indicador"))
			.unique(translate("Indicadores não podem ser repetidos"), (a: any) => a.okb007Iqc001Id)
	}),
	oktbb008: yup.array().when("okb001Formamedicao", {
		is: MeasurementForm.PROJECTS,
		then: yup.array().of(yup.object().shape({
			okb008Id: yup.string(),
			okb008Pra002Id: yup.string().required(translate("Projeto é requerido")),
			okb008Peso: yup.number()
		}))
			.min(1, translate("É necessario preencher ao menos um projeto"))
			.required(translate("É necessario preencher ao menos um projeto"))
			.unique(translate("Projetos não podem ser repetidos"), (a: any) => a.okb008Pra002Id)
	})
});

export const checkInSchema = (translate: Function) => yup.object().shape({
	comment: yup.string().required(translate("Comentário é requerido")),
	date: yup.date().required(translate("Data é requerido")),
	value: yup.string().required(translate("Valor é requerido"))
});

export const checkInMilestoneSchema = (translate: Function) => yup.object().shape({
	comment: yup.string().required(translate("Comentário é requerido")),
	date: yup.date().required(translate("Data é requerido"))
});

export default addOrChangeSchema;
